import { useQuery } from '@tanstack/react-query';
import { getRankings } from '../api';
import { useAuth } from '../auth';
import { useT } from '../i18n';
import PageHeader from '../components/PageHeader';

export default function Rankings() {
  const { user } = useAuth();
  const { t } = useT();
  const q = useQuery({ queryKey: ['rankings'], queryFn: getRankings });
  const rows = q.data?.rankings ?? [];
  const anyPlayed = rows.some((r) => r.matches > 0);
  return (
    <>
      <PageHeader eyebrow="BB Commercial" title={t('r.title')} subtitle={t('r.sub', { median: q.data?.median ?? 1000 })} />
      {q.isLoading && <div className="text-dim text-sm">{t('loading')}</div>}
      {!q.isLoading && !anyPlayed && <div className="mb-4 text-sm text-dim">{t('r.none')}</div>}
      <div className="card overflow-x-auto">
        <table className="w-full text-sm min-w-[28rem]">
          <thead><tr className="text-[11px] uppercase tracking-wider text-dim">
            <th className="text-left px-4 py-2">#</th><th className="text-left py-2"></th><th className="text-right py-2">{t('r.rating')}</th>
            <th className="text-right py-2">{t('r.matches')}</th><th className="text-right py-2">{t('r.games')}</th><th className="text-right py-2">{t('r.tournaments')}</th>
            <th className="text-right py-2">{t('r.hc')}</th><th className="text-right px-4 py-2">{t('r.hc.suggested')}</th>
          </tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.id} className={`border-t border-ink-700/60 ${r.id === user?.id ? 'bg-ball-500/5' : ''}`}>
                <td className="px-4 py-2 stat text-dim">{i + 1}</td>
                <td className="py-2 font-medium">{r.displayName}<span className="text-dim font-normal text-xs ml-2">@{r.username}</span></td>
                <td className="py-2 text-right stat font-semibold">{r.rating}</td>
                <td className="py-2 text-right stat text-dim">{r.matches}</td>
                <td className="py-2 text-right stat text-dim">{r.gamesWon}–{r.gamesLost}</td>
                <td className="py-2 text-right stat text-dim">{r.tournaments}</td>
                <td className="py-2 text-right stat">{r.handicap > 0 ? `+${r.handicap}` : r.handicap}</td>
                <td className={`px-4 py-2 text-right stat ${r.suggestedHandicap !== r.handicap && r.matches > 0 ? 'text-court-400' : 'text-dim'}`}>{r.matches > 0 ? (r.suggestedHandicap > 0 ? `+${r.suggestedHandicap}` : r.suggestedHandicap) : '–'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
